/*
 * foundation.js
 *   foundation library for loading and creation of embeddables
 *
 * Copyright Blue Billywig 2020
 * 
 * Author(s): Janroel Koppen (j.koppen - at - bluebillywig.com)
 */

// Library
var foundation = {};

/**
 * load any bluebillywig script
 * @param String scriptSrc
 * @param String className
 * @param String internalName optional
 * @param Function callback optional
 */
foundation.loadBlueBillywigScript = function(scriptSrc, className, internalName, callback) {
	if (!internalName) internalName = 'script#'+Math.random();

    window.bluebillywig = window.bluebillywig || {};
	bluebillywig._internal = bluebillywig._internal || {};

	function waitForScript() {
		if (typeof bluebillywig._internal[internalName].addEventListener === 'function') {
			bluebillywig._internal[internalName].addEventListener('load', function(ev) {
				if (typeof callback === 'function') callback(true);
			}, true);
		}
	}

	if (bluebillywig[className]) { // already loaded
		if (typeof callback === 'function') callback(true);
	} else if (bluebillywig._internal[internalName]) { // still loading
		waitForScript();
	} else {
		bluebillywig._internal[internalName] = document.createElement('script');
		bluebillywig._internal[internalName].setAttribute('type', 'text/javascript');
		waitForScript();
        bluebillywig._internal[internalName].setAttribute('src', scriptSrc);
		document.getElementsByTagName('head')[0].appendChild(bluebillywig._internal[internalName]);
	}
};

/**
 * load Player script
 * @param Object opts
 * @param Function callback optional
 */
foundation.loadPlayer = function(opts, callback) {
	if (opts) {
		var scriptSrc = opts['playerPath'] + 'player.js';
		foundation.loadBlueBillywigScript(scriptSrc, 'Player', 'PlayerScript', callback);
	} else {
		if (typeof callback === 'function') callback(false);
	}
};

/**
 * load Channel script
 * @param Object opts
 * @param Function callback optional
 */
foundation.loadChannel = function(opts, callback) {
	if (opts) {
		var scriptSrc = opts.scriptSrc || 'https://cdn.bluebillywig.com/apps/channel/latest/app.js';
		foundation.loadBlueBillywigScript(scriptSrc, 'Channel', 'channelScript', callback);
	} else {
		if (typeof callback === 'function') callback(false);
	}
};

/**
 * load Gallery script (DEPRECATED)
 * @param Object opts
 * @param Function callback optional
 */
foundation.loadGallery = function(opts, callback) {
	if (opts) {
		var scriptSrc = opts.scriptSrc || 'https://cdn.bluebillywig.com/apps/gallery/latest/app.js';
		foundation.loadBlueBillywigScript(scriptSrc, 'Gallery', 'galleryScript', callback);
	} else {
		if (typeof callback === 'function') callback(false);
	}
};

/**
 * load Renderer script
 * @param Object opts
 * @param Function callback optional
 */
foundation.loadRenderer = function(opts, callback) {
	if (opts) {
		var scriptSrc = opts.scriptSrc || 'https://cdn.bluebillywig.com/apps/renderer/latest/app.js';
		foundation.loadBlueBillywigScript(scriptSrc, 'Renderer', 'rendererScript', callback);
	} else {
		if (typeof callback === 'function') callback(false);
	}
};

foundation.publicationNameFromBaseUrl = function(baseurl) {
	var publicationName = '';

	if (baseurl && baseurl.match) {
		var matches = null;
		matches = baseurl.match(/^[\w\:]*\/\/([^\/]+)\.bbvms\.com/); // matches testsuite.acc in https://testsuite.acc.bbvms.com
		if (matches && matches.length > 1) publicationName = matches[1];
		matches = baseurl.match(/^[\w\:]*\/\/([^\/]+)\.mainroll\.com/); // matches testsuite.acc in https://testsuite.acc.mainroll.com
		if (matches && matches.length > 1) publicationName = matches[1];
	}

	return publicationName;
};

/**
 * create any bluebillywig instance
 * @param String className
 * @param mixed opts (Object or String)
 * @param Object overrides optional
 * @param Function callback optional
 * @return mixed instance (Object or FALSE on error)
 */
foundation.createBlueBillywigInstance = function(className, opts, overrides, callback) {
	var instancesName = className ? (className.charAt(0).toLowerCase() + className.slice(1) + 's') : 'instances';
	var opts_ = {};
	if (typeof opts === 'string') { // don't ask...
		// e.g. https://testsuite.acc.bbvms.com/p/default/c/1234567.json?foo#bar
		var url = opts;
		url = url.replace(/[?#]+.*$/, ""); // strip query string
		url = url.replace(/\.[^.]*$/, ""); // strip extension
		var parts = url.split('/'); // 'https:', '', 'testsuite.acc.bbvms.com', 'p', 'default', 'c', '1234567'
		if (parts && parts.length > 4) {
			opts_.publicationData = {};
			opts_.publicationData['name'] = foundation.publicationNameFromBaseUrl(parts[0] + '//' + parts[2]);

			opts_.embedData = {};
			opts_.embedData['baseurl'] = parts[0] + '//' + parts[2];
			opts_.embedData['forceSSL'] = 'true';
			opts_.embedData['playoutIndicator'] = parts[3]; // legacy
			opts_.embedData['playoutSafeName'] = parts[4]; // legacy
			opts_.embedData['appIndicator'] = parts[3];
			opts_.embedData['appId'] = parts[4];
		}
		if (parts && parts.length > 6) {
			opts_.embedData['contentIndicator'] = parts[5];
			opts_.embedData['contentId'] = parts[6];
		}
		Object.assign(opts_, overrides);
	} else {
		Object.assign(opts_, opts, overrides);
	}

    window.bluebillywig = window.bluebillywig || {};
	bluebillywig[instancesName] = bluebillywig[instancesName] || [];

	function logEvent(properties) {
		var qs = "";
		for (var prop in properties) {
			if (qs.length == 0) qs += '?'; else qs += '&';
	
			var value = properties[prop];
			if (value == null) value = "";
			qs += prop + '=' + encodeURIComponent(value);
		}
		qs = qs.replace(/-/g, '%2d' ); // is dit nodig?

		var stats = /*((opts && opts.publicationData) ? opts.publicationData['statsserver'] : '') ||*/ 'https://stats.bluebillywig.com';
		var dummy = new Image( 1,1 );	
		dummy.src = stats + qs;
	}

	var instance = false;
	try {
		instance = new bluebillywig[className](opts, overrides);
		if (!foundation.getBlueBillywigInstance(className, instance._id)) {
			bluebillywig[instancesName].push(instance);
		}
	} catch(er) {
		var properties = {'ev': 'pf'};
		properties['why'] = 'error instantiating bluebillywig.' + className + ': '+er.stack.replace(/\(.*\)/gm, '');
		properties['pp'] = ((opts_ && opts_.publicationData) ? opts_.publicationData['name'] : '') || 'unknown';
		if (opts_ && opts_.embedData) properties['aid'] = opts_.embedData['appId'] || opts_.embedData['playoutSafeName']; // NB!
		if (opts_ && opts_.embedData) properties['cid'] = opts_.embedData['contentId'];
		logEvent(properties);
	} finally {
		if (typeof callback === 'function') callback(instance);
	}

	return instance;
};

/**
 * create Player instance
 * @param Object opts
 * @param Object overrides optional
 * @param Function callback optional
 */
foundation.createPlayer = function(opts, overrides, callback) {
	return foundation.createBlueBillywigInstance('Player', opts, overrides, callback);
};

/**
 * create Channel instance
 * @param Object opts
 * @param Object overrides optional
 * @param Function callback optional
 */
foundation.createChannel = function(opts, overrides, callback) {
	return foundation.createBlueBillywigInstance('Channel', opts, overrides, callback);
};

/**
 * create Gallery instance (DEPRECATED)
 * @param Object opts
 * @param Object overrides optional
 * @param Function callback optional
 */
foundation.createGallery = function(opts, overrides, callback) {
	return foundation.createBlueBillywigInstance('Gallery', opts, overrides, callback);
};

/**
 * create Renderer instance
 * @param Object opts
 * @param Object overrides optional
 * @param Function callback optional
 */
foundation.createRenderer = function(opts, overrides, callback) {
	return foundation.createBlueBillywigInstance('Renderer', opts, overrides, callback);
};

/**
 * get any bluebillywig instance
 * @param String className
 * @param String instanceId optional
 * @return mixed instance (Object, NULL if not found or FALSE on error)
 */
foundation.getBlueBillywigInstance = function(className, instanceId) {
	var instance = false;

    window.bluebillywig = window.bluebillywig || {};

	var instancesName = className ? (className.charAt(0).toLowerCase() + className.slice(1) + 's') : 'instances';
	if (bluebillywig[instancesName]) {
		if (instanceId) {
			instance = bluebillywig[instancesName].find(function(inst){ return inst && inst._id === instanceId; }); // NB _id is private?!?
		} else if (bluebillywig[instancesName].length === 1) {
			instance = bluebillywig[instancesName][0];
		}
	}

	return instance;
};

/**
 * get Player instance
 * @param mixed opts (String, Object) optional
 * @return mixed instance (Object, NULL if not found or FALSE on error)
 */
foundation.getPlayer = function(opts) {
	var instanceId = null;

	if (typeof opts === 'string') {
		instanceId = opts;
	} else if (opts && opts.embedData) {
		var appIndicator = opts.embedData['appIndicator'] || opts.embedData['playoutIndicator'] || 'p';
		var appId = opts.embedData['appId'] || opts.embedData['playoutSafeName'] || 'default';
		instanceId = '/' + appIndicator + '/' + appId + '/' + opts.embedData['contentIndicator'] + '/' + opts.embedData['contentId']; // NB convention!
	}

	return foundation.getBlueBillywigInstance('Player', instanceId);
};

/**
 * get Channel instance
 * @param mixed opts (String, Object) optional
 * @return mixed instance (Object, NULL if not found or FALSE on error)
 */
foundation.getChannel = function(opts) {
	var instanceId = null;

	if (typeof opts === 'string') {
		instanceId = opts;
	} else if (opts && opts.embedData) {
		var publicationName = foundation.publicationNameFromBaseUrl(opts.embedData['baseurl']);
		var appIndicator = opts.embedData['appIndicator'] || 'ch';
		var appId = opts.embedData['appId'];
		instanceId = publicationName + '-' + appIndicator + '-' + appId; // NB convention!
		if (opts.embedData['contentIndicator']) instanceId += '-' + opts.embedData['contentIndicator'] + '-' + opts.embedData['contentId'];
	}

	return foundation.getBlueBillywigInstance('Channel', instanceId);
};

/**
 * get Gallery instance (DEPRECATED)
 * @param mixed opts (String, Object) optional
 * @return mixed instance (Object, NULL if not found or FALSE on error)
 */
foundation.getGallery = function(opts) {
	var instanceId = null;

	if (typeof opts === 'string') {
		instanceId = opts;
	} else if (opts && opts.embedData) {
		var publicationName = foundation.publicationNameFromBaseUrl(opts.embedData['baseurl']);
		var appIndicator = opts.embedData['appIndicator'] || 'g';
		var appId = opts.embedData['appId'];
		instanceId = publicationName + '-' + appIndicator + '-' + appId; // NB convention!
		if (opts.embedData['contentIndicator']) instanceId += '-' + opts.embedData['contentIndicator'] + '-' + opts.embedData['contentId'];
	}

	return foundation.getBlueBillywigInstance('Gallery', instanceId);
};

/**
 * get Renderer instance
 * @param mixed opts (String, Object) optional
 * @return mixed instance (Object, NULL if not found or FALSE on error)
 */
foundation.getRenderer = function(opts) {
 	var instanceId = null;

	if (typeof opts === 'string') {
		instanceId = opts;
	} else if (opts && opts.embedData) {
		var appId = '';
		var baseurl = 'https://bb.bbvms.com';
		var publicationName = 'bb';
		if (opts && opts.embedData && typeof opts.embedData['appId'] !== 'undefined') {
			appId = opts.embedData['appId'];
		}
		if (opts && opts.embedData && opts.embedData['baseurl']) {
			baseurl = opts.embedData['baseurl'];
			var matches = null;
			matches = baseurl.match(/^[\w\:]*\/\/([^\/]+)\.bbvms\.com/); // matches testsuite.acc in https://testsuite.acc.bbvms.com
			if (matches && matches.length > 1) publicationName = matches[1];
			matches = baseurl.match(/^[\w\:]*\/\/([^\/]+)\.mainroll\.com/); // matches testsuite.acc in https://testsuite.acc.mainroll.com
			if (matches && matches.length > 1) publicationName = matches[1];
		}
		instanceId = publicationName + '-' + appId; // NB convention, publicationName e.g. "testsuite.acc"!
	}

	return foundation.getBlueBillywigInstance('Renderer', instanceId);
};

/**
 * find placement target
 * @param mixed opts (String, Object) optional
 * @param String appName optional
 * @return Object instance (NULL if not found)
 */
foundation.findTarget = function(opts, appName) {
    appName = appName || 'app';
	// NB Do not change the order, first one to find a spot bails out!

	// Check for a target specified in opts:
	if (opts && typeof opts.target !== 'undefined') {
		// console.debug('[foundation] findTarget found target override');
		return { containerNode: opts.target, replaceNode: void(0) };
	}
	
	// Check for a target using embedData:
	if (opts && typeof opts.embedData !== 'undefined') {
		var srcBase = (opts.embedData['baseurl']) ? opts.embedData['baseurl'].replace(/^\w+:\/\//, '//') : '';
		var srcString = srcBase + '/' + opts.embedData['appIndicator'] + '/'+opts.embedData['appId'];
		if (opts.embedData['contentIndicator']) srcString += '/' + opts.embedData['contentIndicator'] + '/' + opts.embedData['contentId'];
		// console.debug('[foundation] findTarget srcString = ' + srcString);
	
		// Find a script tag with something like srcString in the src
		if (opts.lastScript && opts.lastScript.src && opts.lastScript.src.indexOf(srcString) != -1 ) {
			// console.debug('[foundation] findTarget found opts.lastScript based on src');
			return { containerNode: opts.lastScript.parentElement, replaceNode: opts.lastScript };
		} else {
			var scriptElements = document.querySelectorAll('body script');
			var i = 0, l = scriptElements.length;
			while (i < l) {
				if (scriptElements[i] && scriptElements[i].src && scriptElements[i].src.indexOf(srcString) > -1) break;
				i++;
			}
			if (i < l) { // found
				// console.debug('[foundation] findTarget found script based on src');
				return { containerNode: scriptElements[i].parentElement, replaceNode: scriptElements[i] };
			}
		}

		// Find a script tag with something like srcString in the innerHTML
		if (opts.lastScript && opts.lastScript.innerHTML && opts.lastScript.innerHTML.indexOf(srcString) != -1 ) {
			// console.debug('[foundation] findTarget found opts.lastScript based on innerHTML');
			return { containerNode: opts.lastScript.parentElement, replaceNode: opts.lastScript };
		} else {
			var scriptElements = document.querySelectorAll('body script');
			var i = 0, l = scriptElements.length;
			while (i < l) {
				if (scriptElements[i] && scriptElements[i].innerHTML && scriptElements[i].innerHTML.indexOf(srcString) > -1) break;
				i++;
			}
			if (i < l) { // found
				// console.debug('[foundation] findTarget found script based on innerHTML');
				return { containerNode: scriptElements[i].parentElement, replaceNode: scriptElements[i] };
			}
		}
	}

	// for local development only
	var scriptElements = document.querySelectorAll('body script');
    var re = new RegExp('(^|\/)' + appName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '.*\.js', 'i'); // e.g. (^|\/)channel.*\.js
	var i = 0, l = scriptElements.length;
	while (i < l) {
		if (scriptElements[i] && scriptElements[i].src && scriptElements[i].src.match(re)) break;
		i++;
	}
	if (i < l) { // found
		// console.debug('[foundation] findTarget found ' + appName + '.js based on src');
		return { containerNode: scriptElements[i].parentElement, replaceNode: scriptElements[i] };
	}

	return null;
};

export default foundation;